<template>
  <v-form ref="copyToCreateForm" v-model="valid" lazy-validation>
    <v-row dense style="align-items: center;" v-if="!error.message.length">
      <v-col>
        <v-text-field
          label="Username *"
          :rules="rules.username"
          v-model="invitee.username"
          :disabled="loading"
          maxlength="200"
        >
          <template v-slot:label>
            <h4>
              Username
              <span style="color: red;">
                *
              </span>
            </h4>
          </template>
        </v-text-field>
      </v-col>

      <v-col>
        <v-text-field
          label="Email *"
          :rules="rules.email"
          v-model="invitee.email"
          :disabled="loading"
          maxlength="200"
        >
          <template v-slot:label>
            <h4>
              Email
              <span style="color: red;">
                *
              </span>
            </h4>
          </template></v-text-field
        >
      </v-col>

      <v-col>
        <v-btn
          @click="inviteCopyTo"
          :disabled="!valid"
          style="margin-left: 1rem;"
        >
          Invite
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-else>
      <LoadingBar v-if="error.message.length" :error="error.message" />
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";
import { getForm } from "@/utils";
import rules from "@/utils/rules";
import LoadingBar from "@/components/loaders/LoadingBar";
import { mapState } from "vuex/dist/vuex.common.js";

export default {
  name: "CopyToInvite",
  components: { LoadingBar },
  props: ["inviteCompleteCb"],
  data() {
    return {
      rules: {
        email: [rules.email, rules.required],
        username: [rules.username, rules.required]
      },
      invitee: {
        email: "",
        username: ""
      },
      loading: false,
      valid: false,
      error: {
        message: ""
      }
    };
  },
  mounted() {
    if (this.user.is_copy_to) {
      this.error.message = "Report Recipient has no access to this page";
      return;
    }
  },
  methods: {
    ...mapActions(["notify"]),
    ...mapActions("copyTo", ["invite"]),
    clearForm() {
      this.invitee.email = "";
      this.invitee.username = "";
      this.$nextTick(() => {
        this.$refs.copyToCreateForm.resetValidation();
      });
    },
    // Validate email, option to return string or bool
    email(v, returnBool = false) {
      return (
        !v ||
        /.+@.+\..+/.test(v) ||
        (returnBool ? false : "Email must be valid")
      );
    },
    inviteCopyTo() {
      if (!this.$refs.copyToCreateForm.validate()) return false;

      if (this.invitee.email?.trim() === "") return false;
      // Requires full validation for parent form flow if submit hasn't occurred, but only email validation for invite
      if (!this.email(this.invitee.email?.trim(), true)) return false;
      this.loading = true;
      this.invite({
        email: this.invitee.email?.trim(),
        username: this.invitee.username?.trim()
      }).then(res => {
        if (typeof this.inviteCompleteCb === "function") {
          this.inviteCompleteCb(res);
        }
        let message = res
          ? `${this.invitee.email?.trim()} Invited!`
          : "There was an error inviting this user.";
        if (res) {
          this.clearForm();
        } else {
          if (this.copyToErrors && this.copyToErrors?.length) {
            message = "";
            message += this.copyToErrors.join("\n");
          }
        }
        this.notify({ message, color: res ? "success" : "error" });
        getForm(this).resetValidation();
        this.loading = false;
      });
    }
  },
  computed: {
    ...mapState("copyTo", { copyToErrors: "errors" }),
    ...mapState("auth", ["user"])
  }
};
</script>

<style scoped></style>
